module.exports = __webpack_public_path__ + "img/pad-fill-profile-goal-slide2.065b1ed5.gif";